import { IconProps } from "@/components/icons/types";

export const GalleryIcon = (props: IconProps) => (
    <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect width="13" height="13" rx="2" fill="#67c1f4" />
        <rect x="17" width="13" height="13" rx="2" fill="#67c1f4" />
        <rect y="17" width="13" height="13" rx="2" fill="#67c1f4" />
        <rect x="17" y="17" width="13" height="13" rx="2" fill="#67c1f4" />
    </svg>
);
